import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 pt-3 pb-6 md:px-6 md:pt-5 md:pb-8">
        <div className="flex flex-col gap-y-2 md:flex-row md:items-center md:justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="/images/logo.png"
              alt="株式会社Life Industry"
              className="h-10 w-auto"
            />
          </Link>
          
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 pb-2 text-sm md:flex-nowrap md:justify-end md:text-base">
            <Link
              to="/"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-gray-700 hover:text-black' : 'text-gray-800 hover:text-black'
              }`}
            >
              トップ
            </Link>
            <Link
              to="/company"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-gray-700 hover:text-black' : 'text-gray-800 hover:text-black'
              }`}
            >
              会社概要
            </Link>
            <Link
              to="/services"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-gray-700 hover:text-black' : 'text-gray-800 hover:text-black'
              }`}
            >
              事業内容
            </Link>
            <Link
              to="/contact"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled || !isHomePage ? 'text-gray-700 hover:text-black' : 'text-gray-800 hover:text-black'
              }`}
            >
              お問い合わせ
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
